import service from "../service";

export interface ActiveUserItem {
  user?: string;
  count?: number;
  [key: string]: any;
}

export interface SystemLogItem {
  User?: string;
  IP?: string;
  API?: string;
  BeginTime?: string;
  OPTime?: string;
  RequestMethod?: string;
  RequestData?: string;
  Agent?: string;
  [key: string]: any;
}

export interface ActiveUserResponse {
  activeUsers?: ActiveUserItem[];
  activeUserCount?: number;
  logs?: SystemLogItem[];
  errorCount?: number;
  [key: string]: any;
}

/**
 * 今日访问日志详情（单条记录）
 */
export interface TodayAccessLogItem {
  TraceId?: string;
  Time?: string;
  Path?: string;
  User?: string;
  QueryString?: string;
  BodyData?: string;
  ResponseData?: string;
  HasRequest?: boolean;
  HasResponse?: boolean;
  [key: string]: any;
}

/**
 * 今日访问日志查询参数（全部可选）
 */
export interface TodayAccessLogParams {
  User?: string;
  url?: string;
  start?: string;
  end?: string;
}

export default {
  /**
   * 获取活跃用户
   * GET /api/系统监控/获取活跃用户
   */
  getActiveUsers(): Promise<any> {
    return service({
      method: "GET",
      url: "/系统监控/获取活跃用户",
    });
  },

  /**
   * 获取系统运行状态
   * GET /api/系统监控/系统运行状态
   */
  getSystemStatus(): Promise<any> {
    return service({
      method: "GET",
      url: "/系统监控/系统运行状态",
    });
  },

  /**
   * 获取日志详情
   * GET /api/系统监控/获取日志详情
   * @param params { User?, url?, start?, end? } 任意字段为空则不传
   */
  getTodayAccessLogDetails(params: TodayAccessLogParams = {}): Promise<any> {
    return service({
      method: "GET",
      url: "/系统监控/获取日志详情",
      params,
    });
  },
};
